<template>
    <div id="adopt">
        <div class="row m-0" style="width:100%;" id="adopt-content">
            <div
                class="p-0"
                v-bind:class="{ 'col-lg-5': step == 1, 'col-lg-3': step == 2 }"
            >
                <div class="d-none d-lg-block" style="height:100%;">
                    <div class="row" id="left-div">
                        <div
                            class=""
                            id="cover-img"
                            v-bind:class="{
                                'col-md-6': step == 1,
                                'col-md-12': step == 2
                            }"
                        ></div>
                        <div
                            class="p-5 cover-info"
                            v-bind:class="{
                                'col-md-6': step == 1,
                                'd-none': step == 2
                            }"
                        >
                            <div>
                                <h1 class="mb-5">BECOME A WILDLIFE HERO</h1>
                                <h2 class="mb-4">
                                    JOIN THE WILDLIFE PROTECTOR PRIVATE
                                    MEMBERSHIP
                                </h2>
                                <p>
                                    Be a Wildlife Hero by sponsoring equipment
                                    and tools to the team on the ground so you
                                    can protect the endangered wildlife and stay
                                    in the lookout for the latest updates and
                                    news about wildlife, their environment, and
                                    WWF's work.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-bind:class="{ 'd-none': step == 2 }">
                    <div class="cover-info text-center mt-5 d-block d-lg-none">
                        <h1 class="mb-5 mt-5 p-1">BECOME A WILDLIFE HERO</h1>
                    </div>
                </div>
            </div>
            <div
                class=" p-0"
                id="create-form"
                v-bind:class="{ 'col-lg-7': step == 1, 'col-lg-9': step == 2 }"
            >
                <header class="site-header">
                    <div class="container-fluid">
                        <nav
                            class="navbar navbar-expand-lg navbar-light navbar-offcanvas py-0"
                        >
                            <a class="navbar-brand" href="/">
                                <img
                                    class="navbar-logo"
                                    src="/images/WWF_Logo.jpg"
                                />
                            </a>
                        </nav>
                    </div>
                </header>
                <div class="row p-0 m-0">
                    <div
                        class="col-12 p-4"
                        id="select-package"
                        v-bind:class="{ 'd-none': step == 2 }"
                    >
                        <div class="row">
                            <div class="col-md-2"></div>
                            <div class="col-md-8 p-0">
                                <div class="card-body p-0">
                                    <div class="p-5">
                                        <h1 class="mb-4">
                                            SELECT YOUR CONTRIBUTION
                                        </h1>
                                        <div class="row">
                                            <div class="col-md-12 p-0">
                                                <div class="row" id="monthly">
                                                    <div
                                                        class="col-4 p-0"
                                                        v-for="tier in tiers"
                                                        :key="tier.id"
                                                    >
                                                        <div
                                                            class="circle "
                                                            @click="
                                                                changeTier(
                                                                    tier.id
                                                                )
                                                            "
                                                            :class="
                                                                tier.id ==
                                                                form.tier
                                                                    ? 'circle-active'
                                                                    : 'circle-nactive'
                                                            "
                                                        >
                                                            <p
                                                                class="mb-0 pl-3 pr-3 text-center"
                                                            >
                                                                ${{
                                                                    tier.amount
                                                                }}/mo
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <!-- <div class="col-4 p-0"><div class="circle " @click="changePricing('price1')" v-bind:class="form.pricing === 'price1' ? 'circle-active' : 'circle-nactive'" ><p class="mb-0 pl-3 pr-3 text-center">${{pricing.price1}}/mo</p></div></div> -->
                                                </div>
                                            </div>

                                            <div
                                                class="col-12 p-0"
                                                style="background-color: inherit; color: inherit;"
                                            >
                                                <ul
                                                    class="pl-2 pt-3 mb-0 pl-md-0 benefit-list"
                                                >
                                                    <li
                                                        v-for="benefit in benefits.all"
                                                        :key="benefit"
                                                    >
                                                        <!-- selectedTier.benefit[0].name -->
                                                        <!-- <img width="20px" :src="'/storage/imgs/icons/' + (benefit === selectedTier.benefit[0].name.filter ? 'check_nactive.png':'check_active.png')"> {{ benefit }} -->
                                                        <div
                                                            class="float-left mr-2"
                                                        >
                                                            <img
                                                                width="20px"
                                                                :src="
                                                                    '/storage/imgs/icons/' +
                                                                        (selectedTier.benefit
                                                                            .map(
                                                                                item =>
                                                                                    item.name
                                                                            )
                                                                            .indexOf(
                                                                                benefit
                                                                            ) >=
                                                                        0
                                                                            ? 'check_active.png'
                                                                            : 'check_nactive.png')
                                                                "
                                                            />
                                                        </div>
                                                        <div>{{ benefit }}</div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row w-100 m-0" id="bah-btn">
                                        <div
                                            class="col-12 text-center wwf-font "
                                            v-on:click="step = 2"
                                        >
                                            BE A HERO >
                                        </div>
                                    </div>
                                </div>

                                <br />
                                <p class="text-center" v-if="this.can_observe">
                                    <a
                                        class="text-body"
                                        :href="
                                            '/' + this.adoptee.slug + '/observe'
                                        "
                                        title="Being a Wildlife Observer means you will be receiving conservation news and ways which you can help WWF-Singapore protect the diversity of the life on Earth."
                                        >I would like to receive more
                                        information as a Wildlife Observer</a
                                    >
                                    <br />

                                    <small class="d-lg-none"
                                        >Being a Wildlife Observer means you
                                        will be receiving conservation news and
                                        ways which you can help WWF-Singapore
                                        protect the diversity of the life on
                                        Earth.</small
                                    >
                                </p>
                            </div>
                            <div class="col-md-2"></div>
                        </div>
                    </div>
                    <div
                        class="col-12 p-4"
                        v-bind:class="{ 'd-none': step == 1 }"
                    >
                        <div class="row my-2 my-md-5">
                            <div class="forms col-md-7  mt-5">
                                <div
                                    class="p-md-4"
                                    style="padding-bottom: 0 !important;"
                                >
                                    <div class="card-body p-5 mb-0">
                                        <h1>
                                            {{
                                                sponsor == 1
                                                    ? "SPONSOR AN EQUIPMENT"
                                                    : "BECOME A HERO"
                                            }}
                                        </h1>
                                        <div
                                            class="row"
                                            v-if="
                                                this.createaccount &&
                                                    !this.user.email
                                            "
                                        >
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label>First name</label>
                                                    <input
                                                        id="firstname"
                                                        type="text"
                                                        class="form-control"
                                                        value=""
                                                        name="firstname"
                                                        v-model="form.firstname"
                                                        v-bind:class="{
                                                            'is-invalid':
                                                                errors.firstname
                                                        }"
                                                    />
                                                    <span
                                                        class="invalid-feedback"
                                                        role="alert"
                                                        v-if="errors.firstname"
                                                    >
                                                        <strong>{{
                                                            errors.firstname
                                                        }}</strong>
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label>Last name</label>
                                                    <input
                                                        id="lastname"
                                                        type="text"
                                                        class="form-control"
                                                        name="lastname"
                                                        v-model="form.lastname"
                                                        v-bind:class="{
                                                            'is-invalid':
                                                                errors.lastname
                                                        }"
                                                    />
                                                    <span
                                                        class="invalid-feedback"
                                                        role="alert"
                                                        v-if="errors.lastname"
                                                    >
                                                        <strong>{{
                                                            errors.lastname
                                                        }}</strong>
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label>Email address</label>
                                                    <input
                                                        id="email"
                                                        type="email"
                                                        class="form-control"
                                                        name="email"
                                                        placeholder="example@email.com"
                                                        v-model="form.email"
                                                        v-bind:class="{
                                                            'is-invalid':
                                                                errors.email
                                                        }"
                                                    />
                                                    <span
                                                        class="invalid-feedback"
                                                        role="alert"
                                                        v-if="errors.email"
                                                    >
                                                        <strong>{{
                                                            errors.email
                                                        }}</strong>
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label>Password</label>
                                                    <input
                                                        id="password"
                                                        type="password"
                                                        class="form-control"
                                                        name="password"
                                                        v-bind:class="{
                                                            'is-invalid':
                                                                errors.password
                                                        }"
                                                        placeholder="Password"
                                                        v-model="form.password"
                                                    />
                                                    <span
                                                        class="invalid-feedback"
                                                        role="alert"
                                                        v-if="errors.password"
                                                    >
                                                        <strong>{{
                                                            errors.password
                                                        }}</strong>
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="col-md-12">
                                                <p style="font-size:0.7rem;">
                                                    By creating an account, I
                                                    agree to receive updates
                                                    from WWF-Singapore in
                                                    accordance with our
                                                    <a
                                                        href="https://www.wwf.sg/wwf_singapore/pdp_policy"
                                                        class="personal-data-protection-policy"
                                                        >Personal Data
                                                        Protection Policy.</a
                                                    >
                                                </p>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <!-- <div class="col-md-6">
                                                <div class="form-group">
                                                    <label>Unit:</label>
                                                    <input
                                                        type="text"
                                                        class="form-control"
                                                        v-model="form.unit"
                                                        v-bind:class="{
                                                            'is-invalid':
                                                                errors.unit
                                                        }"
                                                    />
                                                    <span
                                                        class="invalid-feedback"
                                                        role="alert"
                                                        v-if="errors.unit"
                                                    >
                                                        <strong>{{
                                                            errors.unit
                                                        }}</strong>
                                                    </span>
                                                </div>
                                            </div> -->
                                            <!-- <div
                                                class="col-md-6"
                                                v-if="enableNRIC()"
                                            >
                                                <div class="form-group">
                                                    <label>NRIC:</label>
                                                    <input
                                                        type="text"
                                                        class="form-control"
                                                        v-model="form.nric"
                                                        v-bind:class="{
                                                            'is-invalid':
                                                                errors.nric
                                                        }"
                                                    />
                                                    <span
                                                        class="invalid-feedback"
                                                        role="alert"
                                                        v-if="errors.nric"
                                                    >
                                                        <strong>{{
                                                            errors.nric
                                                        }}</strong>
                                                    </span>
                                                </div>
                                            </div> -->

                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label>Country:</label>
                                                    <select
                                                        id="country"
                                                        v-model="form.country"
                                                        class="form-control"
                                                        name="country"
                                                        @change="
                                                            countryOnChange
                                                        "
                                                    >
                                                        <option
                                                            :value="
                                                                country.sortname
                                                            "
                                                            v-for="country in countries"
                                                            v-bind:key="
                                                                country.id
                                                            "
                                                            >{{
                                                                country.name
                                                            }}</option
                                                        >
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label>Post code:</label>
                                                    <input
                                                        type="text"
                                                        class="form-control"
                                                        v-model="form.postcode"
                                                        v-bind:class="{
                                                            'is-invalid':
                                                                errors.postcode
                                                        }"
                                                    />
                                                    <span
                                                        class="invalid-feedback"
                                                        role="alert"
                                                        v-if="errors.postcode"
                                                    >
                                                        <strong>{{
                                                            errors.postcode
                                                        }}</strong>
                                                    </span>
                                                </div>
                                            </div>

                                            <div class="col-md-12">
                                                <div class="form-group">
                                                    <label>Address:</label>
                                                    <input
                                                        type="text"
                                                        class="form-control"
                                                        v-model="form.address"
                                                        v-bind:class="{
                                                            'is-invalid':
                                                                errors.address
                                                        }"
                                                    />
                                                    <span
                                                        class="invalid-feedback"
                                                        role="alert"
                                                        v-if="errors.address"
                                                    >
                                                        <strong>{{
                                                            errors.address
                                                        }}</strong>
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="col-md-12">
                                                <div
                                                    class="row"
                                                    v-if="form.country !== 'SG'"
                                                >
                                                    <div
                                                        class="form-group col-6"
                                                    >
                                                        <label for="state"
                                                            >State</label
                                                        >
                                                        <!-- <select id="state" v-model="form.state" class="form-control" name="state" v-bind:class="{'is-invalid' : errors.state}" @change="stateOnChange">
                                        <option :value="state.name" v-for="(state, index) in states" v-bind:key="index+20">{{ state.name }}</option>
                                      </select> -->
                                                        <input
                                                            type="text"
                                                            id="state"
                                                            v-model="form.state"
                                                            class="form-control"
                                                            name="state"
                                                            v-bind:class="{
                                                                'is-invalid':
                                                                    errors.state
                                                            }"
                                                        />
                                                        <span
                                                            class="invalid-feedback"
                                                            role="alert"
                                                            v-if="errors.state"
                                                        >
                                                            <strong>{{
                                                                errors.state
                                                            }}</strong>
                                                        </span>
                                                    </div>
                                                    <div
                                                        class="form-group col-6"
                                                    >
                                                        <label for="city"
                                                            >City</label
                                                        >
                                                        <!-- <select id="city" v-model="form.city" class="form-control" name="city" v-bind:class="{'is-invalid' : errors.city}">
                                        <option :value="city.name" v-for="(city , index) in cities" v-bind:key="index+10">{{ city.name }}</option>
                                      </select> -->
                                                        <input
                                                            type="text"
                                                            id="city"
                                                            v-model="form.city"
                                                            class="form-control"
                                                            name="city"
                                                            v-bind:class="{
                                                                'is-invalid':
                                                                    errors.city
                                                            }"
                                                        />
                                                        <span
                                                            class="invalid-feedback"
                                                            role="alert"
                                                            v-if="errors.city"
                                                        >
                                                            <strong>{{
                                                                errors.city
                                                            }}</strong>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-12">
                                                <div class="form-group mb-0">
                                                    <label
                                                        >Date of Birth:</label
                                                    >
                                                    <div class="row">
                                                        <div class="col-md-4">
                                                            <div
                                                                class="form-group"
                                                            >
                                                                <select
                                                                    class="form-control "
                                                                    v-model="
                                                                        day
                                                                    "
                                                                >
                                                                    <option
                                                                        v-for="day_num in days_count"
                                                                        v-bind:key="
                                                                            day_num
                                                                        "
                                                                        :value="
                                                                            day_num
                                                                        "
                                                                        >{{
                                                                            day_num
                                                                        }}</option
                                                                    >
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-4">
                                                            <div
                                                                class="form-group"
                                                            >
                                                                <select
                                                                    class="form-control "
                                                                    v-model="
                                                                        month
                                                                    "
                                                                    @change="
                                                                        changeDay
                                                                    "
                                                                >
                                                                    <option
                                                                        v-for="(data,
                                                                        month) in months_days"
                                                                        v-bind:key="
                                                                            data.name
                                                                        "
                                                                        :value="
                                                                            month
                                                                        "
                                                                        >{{
                                                                            data.name
                                                                        }}</option
                                                                    >
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-4">
                                                            <div
                                                                class="form-group"
                                                            >
                                                                <select
                                                                    class="form-control "
                                                                    v-model="
                                                                        year
                                                                    "
                                                                    @change="
                                                                        changeDay
                                                                    "
                                                                >
                                                                    <option
                                                                        v-for="year in years"
                                                                        v-bind:key="
                                                                            year
                                                                        "
                                                                        :value="
                                                                            year
                                                                        "
                                                                        >{{
                                                                            year
                                                                        }}</option
                                                                    >
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <!-- <DatePicker v-model="form.birthdate" :input-props='{ placeholder: "Please enter your date of birth", readonly: true, style: "font-family: Helvetica; font-size:0.9rem;", class:{"form-control is-invalid" : errors.birthdate, "form-control" : !errors.birthdate} }'></DatePicker> -->
                                                    <span
                                                        class="invalid-feedback"
                                                        role="alert"
                                                        v-if="errors.birthdate"
                                                    >
                                                        <strong>{{
                                                            errors.birthdate
                                                        }}</strong>
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="col-md-12">
                                                <div class="form-group">
                                                    <label
                                                        >Enter your card
                                                        details</label
                                                    >
                                                    <card
                                                        class="stripe-card"
                                                        :class="{ complete }"
                                                        :stripe="
                                                            this.stripe_key
                                                        "
                                                        :options="stripeOptions"
                                                        ref="stripeCard"
                                                        @change="change($event)"
                                                    />
                                                    <span
                                                        class="invalid-feedback"
                                                        role="alert"
                                                        v-if="errors.card_info"
                                                    >
                                                        <strong>{{
                                                            errors.card_info
                                                        }}</strong>
                                                    </span>
                                                </div>
                                            </div>

                                            <div class="col-md-12">
                                                <div class="form-group">
                                                    <label
                                                        >Cardholder name:</label
                                                    >
                                                    <input
                                                        type="text"
                                                        class="form-control"
                                                        v-model="
                                                            form.card_holdername
                                                        "
                                                        v-bind:class="{
                                                            'is-invalid':
                                                                errors.card_holdername
                                                        }"
                                                    />
                                                    <span
                                                        class="invalid-feedback"
                                                        role="alert"
                                                        v-if="
                                                            errors.card_holdername
                                                        "
                                                    >
                                                        <strong>{{
                                                            errors.card_holdername
                                                        }}</strong>
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="col-md-12">
                                                <label
                                                    v-bind:class="{
                                                        'd-none':
                                                            form.sponsor == 1
                                                    }"
                                                >
                                                    Set your payment
                                                    frequency</label
                                                >
                                                <div
                                                    class="row payment-frequency-section mt-4"
                                                    v-bind:class="{
                                                        'd-none':
                                                            form.sponsor == 1
                                                    }"
                                                >
                                                    <div class="col-4">
                                                        <div
                                                            class="payment-frequency text-center"
                                                            @click="
                                                                changeInterval(
                                                                    'monthly'
                                                                )
                                                            "
                                                            v-bind:class="
                                                                form.interval ===
                                                                'monthly'
                                                                    ? 'active'
                                                                    : ''
                                                            "
                                                        >
                                                            <div>
                                                                <strong
                                                                    >Monthly</strong
                                                                >
                                                                <p>
                                                                    ${{
                                                                        selectedAmount
                                                                    }}
                                                                    / month
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-4">
                                                        <div
                                                            class="payment-frequency text-center"
                                                            @click="
                                                                changeInterval(
                                                                    'biannual'
                                                                )
                                                            "
                                                            v-bind:class="
                                                                form.interval ===
                                                                'biannual'
                                                                    ? 'active'
                                                                    : ''
                                                            "
                                                        >
                                                            <div>
                                                                <strong
                                                                    >Bi-annual</strong
                                                                >
                                                                <p>
                                                                    ${{
                                                                        selectedAmount *
                                                                            6
                                                                    }}
                                                                    <br />/ 6
                                                                    months
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-4">
                                                        <div
                                                            class="payment-frequency text-center"
                                                            @click="
                                                                changeInterval(
                                                                    'annual'
                                                                )
                                                            "
                                                            v-bind:class="
                                                                form.interval ===
                                                                'annual'
                                                                    ? 'active'
                                                                    : ''
                                                            "
                                                        >
                                                            <div>
                                                                <strong
                                                                    >Annual</strong
                                                                >
                                                                <p>
                                                                    ${{
                                                                        selectedAmount *
                                                                            12
                                                                    }}
                                                                    / year
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div
                                                    class="custom-control custom-checkbox mb-2 mt-4"
                                                    v-bind:class="{
                                                        'd-none':
                                                            form.sponsor == 1
                                                    }"
                                                    title="Physical welcome pack will be sent after Circuit Breaker period ceases and is available only to Singapore addresses."
                                                >
                                                    <input
                                                        type="checkbox"
                                                        name="save_earth"
                                                        id="save_earth"
                                                        class="custom-control-input"
                                                        v-model="
                                                            form.save_earth
                                                        "
                                                    />
                                                    <label
                                                        for="save_earth"
                                                        class="custom-control-label orange"
                                                    >
                                                        I would like to save the
                                                        earth and opt out from
                                                        the physical welcome
                                                        pack.
                                                    </label>
                                                </div>
                                                <div class="col-md-12">
                                                    <div class="row mb-0 mt-3">
                                                        <!-- <div class="col-md-3"></div>
                                        <div class="col-md-3">
                                        </div> -->
                                                        <div
                                                            class="col-md-12 text-center"
                                                        >
                                                            <button
                                                                type="submit"
                                                                :disabled="
                                                                    wait == 1
                                                                "
                                                                v-on:click="pay"
                                                                class="btn btn-primary"
                                                                style="border-radius: 7px"
                                                            >
                                                                <span>{{
                                                                    sponsor == 1
                                                                        ? "SPONSOR AN EQUIPMENT"
                                                                        : "BECOME A HERO"
                                                                }}</span>
                                                                <img
                                                                    :src="
                                                                        '/storage/imgs/checkout/loading_(transparent).gif'
                                                                    "
                                                                    v-bind:class="
                                                                        wait ==
                                                                        1
                                                                            ? ''
                                                                            : 'd-none'
                                                                    "
                                                                    width="30"
                                                                    height="30"
                                                                    style="margin-left:20px;margin-bottom:2px;"
                                                                />
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div
                                class="cart col-md-5 order-first order-md-last p-0"
                            >
                                <div
                                    class="p-3 p-md-4 p-lg-5 contribution-items"
                                >
                                    <h4
                                        v-bind:class="{
                                            'd-none': form.sponsor == 1
                                        }"
                                    >
                                        You are contributing to:
                                    </h4>
                                    <div
                                        class="row no-gutters align-items-center"
                                        v-bind:class="{
                                            'd-none': form.sponsor == 1
                                        }"
                                    >
                                        <div class="col-2">
                                            <img
                                                style="height: auto;"
                                                class="w-100 rounded-lg"
                                                :src="
                                                    '/storage/' + adoptee.image
                                                "
                                                :alt="adoptee.name"
                                            />
                                        </div>
                                        <div class="col-10">
                                            <div class="ml-3">
                                                <h5>
                                                    Adopting & protecting a
                                                    {{ adoptee.name }}
                                                </h5>
                                                <div class="row no-gutters">
                                                    <div class="col-6">
                                                        $
                                                        {{
                                                            plans[
                                                                this.form
                                                                    .interval
                                                            ]
                                                        }}
                                                    </div>
                                                    <div
                                                        class="col-6 text-right"
                                                    >
                                                        $
                                                        {{
                                                            plans[
                                                                this.form
                                                                    .interval
                                                            ]
                                                        }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <h5 class="mt-4">Add-ons:</h5>
                                    <div class="gifts">
                                        <div
                                            class="gift row no-gutters mb-4"
                                            v-for="gift in form.cart"
                                            :key="gift.name"
                                        >
                                            <div class="col-2">
                                                <img
                                                    :title="gift.description"
                                                    class="card-img-top w-100"
                                                    :src="
                                                        '/storage/' + gift.image
                                                    "
                                                    :alt="gift.name"
                                                />
                                                <span
                                                    class="badge badge-pill badge-orange"
                                                >
                                                    {{ gift.quantity }}
                                                </span>
                                            </div>
                                            <div class="col-10">
                                                <div class="ml-3">
                                                    <h5
                                                        :title="
                                                            gift.description
                                                        "
                                                    >
                                                        {{ gift.name }}
                                                    </h5>
                                                    <div
                                                        class="row no-gutter align-items-center"
                                                    >
                                                        <div class="col-2">
                                                            ${{ gift.price }}
                                                        </div>
                                                        <div
                                                            class="col-2 text-center"
                                                        >
                                                            X
                                                        </div>
                                                        <div
                                                            class="col-5 col-md-4 pl-0 pr-0"
                                                        >
                                                            <div
                                                                class="input-group input-group-sm"
                                                            >
                                                                <div
                                                                    class="input-group-append"
                                                                >
                                                                    <button
                                                                        class="btn btn-outline-secondary"
                                                                        type="button"
                                                                        id="button-addon2"
                                                                        :disabled="
                                                                            !gift.quantity
                                                                        "
                                                                        @click="
                                                                            gift.quantity -= 1
                                                                        "
                                                                    >
                                                                        -
                                                                    </button>
                                                                </div>
                                                                <div
                                                                    class="input-group-prepend"
                                                                >
                                                                    <button
                                                                        class="btn btn-outline-secondary"
                                                                        type="button"
                                                                        id="button-addon1"
                                                                        :disabled="
                                                                            gift.quantity >=
                                                                                10
                                                                        "
                                                                        @click="
                                                                            gift.quantity += 1
                                                                        "
                                                                    >
                                                                        +
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div
                                                            class="col-2 text-right"
                                                        >
                                                            ${{
                                                                gift.price *
                                                                    gift.quantity
                                                            }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <h6 class="text-orange">SUBTOTAL:</h6>
                                    <table
                                        class="table table-borderless table-hover table-sm"
                                    >
                                        <tr
                                            v-bind:class="{
                                                'd-none': form.sponsor == 1
                                            }"
                                        >
                                            <td>RECURRING GIFT</td>
                                            <td class="font-weight-bold">S$</td>
                                            <td
                                                class="text-right font-weight-bold"
                                            >
                                                {{ monthlyGift }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>ONE-TIME GIFT</td>
                                            <td class="font-weight-bold">S$</td>
                                            <td
                                                class="text-right font-weight-bold"
                                            >
                                                {{ oneTimeGift }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="font-weight-bold">
                                                <strong
                                                    >TOTAL CONTRIBUTION</strong
                                                >
                                            </td>
                                            <td class="font-weight-bold">S$</td>
                                            <td
                                                class="text-right font-weight-bold"
                                            >
                                                {{ monthlyGift + oneTimeGift }}
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 p-0" v-bind:class="{ 'd-none': step == 2 }">
                <div class="cover-info text-center mt-5 d-block d-lg-none">
                    <h2 class="mb-1 p-1">
                        JOIN THE WILDLIFE PROTECTOR PRIVATE COMMUNITY
                    </h2>
                    <p class="mb-2 p-5">
                        Become a wildlife Hero by sponsoring equipment and tools
                        to the team on the ground so you can protect the
                        endangered wildlife and safeguard their homes!
                    </p>
                    <div id="cover-img" style="height:80vh; width:100%;"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DatePicker from "v-calendar/lib/components/date-picker.umd";

import {
    Card,
    createPaymentMethod,
    createToken
} from "vue-stripe-elements-plus";

const countries = require("country-state-city/lib/country.json");
const states = require("country-state-city/lib/state.json");
const cities = require("country-state-city/lib/city.json");

export default {
    props: [
        "tier",
        "user",
        "steps",
        "gifts",
        "tiers",
        "sponsor",
        "adoptee",
        "benefits",
        "birthdate",
        "stripe_key",
        "token_csrf",
        "can_observe",
        "stripeintent",
        "pricing_decl",
        "createaccount",
        "additional"
    ],

    components: {
        DatePicker,
        Card
    },

    data() {
        return {
            onetimegift_total: 0,
            day: 1,
            days_count: 1,
            year: 2020,
            years: [],
            month: "Jan",
            months_days: {},
            step: this.steps,
            countries: countries,
            states: [],
            cities: [],
            complete: false,
            countryID: 0,
            stateID: 0,
            pricing: {},
            wait: 0,
            stripeOptions: {
                style: {
                    base: {
                        color: "#32325d",
                        lineHeight: "18px",
                        fontFamily: '"Raleway", Helvetica, sans-serif',
                        fontSmoothing: "antialiased",
                        fontSize: "16px",
                        "::placeholder": {
                            color: "#aab7c4"
                        }
                    },
                    invalid: {
                        color: "#fa755a",
                        iconColor: "#fa755a"
                    }
                },
                hidePostalCode: true
            },
            form: {
                _token: this.token_csrf,
                welcome_pack: true,
                cart: {},
                interval: "biannual",
                tier: this.tier,
                pricing: this.pricing_decl,
                firstname: this.user.fname || "",
                lastname: this.user.lname || "",
                email: this.user.email || "",
                // phone: this.user.phone || "",
                // clean_phone_format: '',
                // _token: this.token,
                password: "",
                birthdate: this.birthdate,
                country: this.user.country || "SG",
                postcode: this.user.postcode || "",
                address: this.user.address || "",
                unit: this.user.unit_number || "",
                nric: this.user.nric || "",
                city: this.user.city || "",
                state: this.user.state || "",
                save_earth: this.user.save_earth || true,
                card_holdername: "",
                sponsor: this.sponsor,
                stripe: {
                    payment_method: "",
                    token: "",
                    brand: "",
                    last4: this.user || "",
                    exp_month: this.user || "",
                    exp_year: this.user || ""
                }
            },
            is_form_dirty: false,
            is_form_success: false,
            errors: {
                postcode: "",
                address: "",
                city: "",
                unit: "",
                nric: "",
                state: "",
                birthdate: "",
                card_holdername: "",
                card_info: "",
                firstname: "",
                lastname: "",
                email: "",
                password: ""
            }
        };
    },
    created() {
        for (let year = 1940; year <= new Date().getFullYear(); year++) {
            this.years.push(year);
        }
        this.monthsDay();
        this.countryOnChange();
    },
    methods: {
        validate(number, result) {
            this.errors.phone = result.isValid
                ? ""
                : "The phone number is invalid.";
            this.fields.clean_phone_format = result.isValid
                ? result.number.e164.replace("+", "")
                : "";
        },
        changeDay() {
            this.days_count = this.months_days[this.month].days;
        },
        monthsDay() {
            fetch(
                "https://raw.githubusercontent.com/brandonwamboldt/data/master/datetime/months-detailed.json"
            )
                .then(res => res.json())
                .then(res => {
                    this.months_days = res;
                    this.days_count = this.months_days[this.month].days;

                    const birthdate = this.birthdate.split("/");
                    // console.log(parseInt(birthdate[1]));
                    this.day = parseInt(birthdate[1]);
                    this.month = birthdate[0];
                    this.year = birthdate[2];
                })
                .catch(error => console.log(error));
        },
        countryOnChange() {
            const country = this.form.country;
            this.countryID = countries.filter(function(item) {
                if (item.sortname == country) {
                    // console.log(item)
                    return item;
                }
            }).id;

            const countryID = this.countryID;

            const statesTemp = states.filter(function(item) {
                if (item.country_id == countryID) {
                    return item;
                }
            });

            this.states = statesTemp;
        },
        enableNRIC() {
            return this.form.country == "SG";
        },
        stateOnChange() {
            const state = this.form.state;
            this.stateID = states.filter(function(item) {
                if (item.name == state) {
                    return item;
                }
            })[0].id;

            const stateID = this.stateID;

            const cityTemp = cities.filter(function(item) {
                if (item.state_id == stateID) {
                    return item;
                }
            });

            this.cities = cityTemp;
        },
        changeTier(tier) {
            this.form.tier = tier;
            this.is_form_dirty = true;
        },
        changeInterval(interval) {
            return (this.form.interval = interval);
        },
        getErrorMsg(name) {
            if (name == "stripe") {
                return this.errors[name];
            }
            return this.errors[name][0];
        },
        pay() {
            createToken().then(data => {
                this.form.stripe.token = data.token.id;
                this.form.stripe.brand = data.token.card.brand;
                this.form.stripe.last4 = data.token.card.last4;
                this.form.stripe.exp_month = data.token.card.exp_month;
                this.form.stripe.exp_year = data.token.card.exp_year;

                this.createPaymentMethodCard(data.token.type)
                    .then(data => {
                        // console.log(data.paymentMethod.id);
                        this.form.stripe.payment_method = data.paymentMethod.id;
                    })
                    .then(data => {
                        this.processPayment();
                    });
            });
        },
        async createPaymentMethodCard(type) {
            let se = this.$refs.stripeCard.$refs.element;
            let paymentMethod = await createPaymentMethod({
                type: type,
                card: se._element,
                billing_details: {
                    name: this.form.card_holdername
                }
            });
            return paymentMethod;
        },
        processPayment() {
            let monthly_gift = 0;
            if (this.sponsor != 1) {
                switch (this.form.interval) {
                    case "monthly":
                        monthly_gift = this.plans.monthly;
                        break;
                    case "biannual":
                        monthly_gift = this.plans.biannual;
                        break;
                    case "annual":
                        monthly_gift = this.plans.annual;
                        break;
                }
            }
            const items = [];
            for (const item in this.form.cart) {
                if (this.form.cart.hasOwnProperty(item)) {
                    const gift = this.form.cart[item];
                    items.push({
                        item_id: gift.id,
                        item_name: gift.name,
                        price: gift.price,
                        quantity: gift.quantity
                    });
                }
            }
            if (this.sponsor != 1) {
                this.$gtag.event("begin_checkout", {
                    currency: "SGD",
                    value: monthly_gift + this.onetimegift_total,
                    items: items
                });
            }
            this.$gtag.event("add_to_wishlist", {
                currency: "SGD",
                value: monthly_gift + this.onetimegift_total,
                items: items
            });
            this.wait = 1;
            if (this.form.sponsor == 1 && this.onetimegift_total == 0) {
                Swal.fire({
                    icon: "warning",
                    title: "Your cart seems empty.",
                    html:
                        "Please check your cart again, you might have forgotten to add an equipment."
                });
                this.wait = 0;
                return false;
            }

            this.form.birthdate = this.month + " " + this.day + "," + this.year;
            let urlRoute =
                this.createaccount && !this.user.email
                    ? `/${this.adoptee.slug}/adopt/createaccount`
                    : `/${this.adoptee.slug}/adopt`;
            fetch(urlRoute, {
                method: "post",
                body: JSON.stringify(this.form),
                headers: {
                    "content-type": "application/json",
                    Accept: "application/json"
                }
            })
                .then(data => data.json())
                .then(data => {
                    if (typeof data.errors != "undefined") {
                        this.wait = 0;
                        this.errors.address =
                            typeof data.errors.address != "undefined"
                                ? data.errors.address[0]
                                : "";
                        this.errors.unit =
                            typeof data.errors.unit != "undefined"
                                ? data.errors.unit[0]
                                : "";
                        this.errors.postcode =
                            typeof data.errors.postcode != "undefined"
                                ? data.errors.postcode[0]
                                : "";
                        this.errors.birthdate =
                            typeof data.errors.birthdate != "undefined"
                                ? data.errors.birthdate[0]
                                : "";
                        this.errors.city =
                            typeof data.errors.city != "undefined"
                                ? data.errors.city[0]
                                : "";
                        this.errors.nric =
                            typeof data.errors.nric != "undefined"
                                ? data.errors.nric[0]
                                : "";
                        this.errors.state =
                            typeof data.errors.state != "undefined"
                                ? data.errors.state[0]
                                : "";
                        this.errors.card_holdername =
                            typeof data.errors.card_holdername != "undefined"
                                ? data.errors.card_holdername[0]
                                : "";
                        this.errors.firstname =
                            typeof data.errors.firstname != "undefined"
                                ? data.errors.firstname[0]
                                : "";
                        this.errors.lastname =
                            typeof data.errors.lastname != "undefined"
                                ? data.errors.lastname[0]
                                : "";
                        this.errors.email =
                            typeof data.errors.email != "undefined"
                                ? data.errors.email[0]
                                : "";
                        this.errors.password =
                            typeof data.errors.password != "undefined"
                                ? data.errors.password[0]
                                : "";
                    } else {
                        if (data.status == true) {
                            // let timerInterval
                            // Swal.fire({
                            //   icon:"success",
                            //   title: 'Congratulation!',
                            //   html: 'You are now a wildlife Hero! Thank you for contributing to save tigers from extinction!',
                            //   timer: 5000,
                            //   timerProgressBar: true,
                            //   footer: 'Redirecting...',
                            //   onBeforeOpen: () => {
                            //     Swal.showLoading()
                            //     timerInterval = setInterval(() => {
                            //       const content = Swal.getContent()
                            //     }, 100)
                            //   },
                            //   onClose: () => {
                            //     clearInterval(timerInterval)
                            //     window.location.replace("/user/adoptions")
                            //   }
                            // }).then((result) => {
                            //   if (result.dismiss === Swal.DismissReason.timer) {
                            if (this.sponsor != 1) {
                                this.$gtag.event("purchase", {
                                    transaction_id: data.transaction_id,
                                    currency: "SGD",
                                    value:
                                        monthly_gift + this.onetimegift_total,
                                    items: items
                                });
                            }
                            this.$gtag.event("select_item", {
                                items: items
                            });

                            this.is_form_success = true;

                            this.sendSubscription(
                                this.form,
                                this.monthlyGift,
                                this.oneTimeGift,
                                this.adoptee,
                                "FR_Adoption_Hero_Successful",
                                () => {}
                            );

                            const eventData = {
                                eventName:
                                    this.adoptee?.name + "_adopt_success",
                                data: {
                                    interval: this.form.interval,
                                    adoptee: this.adoptee?.name,
                                    tier: this.form.tier,
                                    pricing: this.form.pricing_decl,
                                    name:
                                        this.form.firstname +
                                        " " +
                                        this.form.lastname,
                                    email: this.form.email,
                                    birthdate: this.form.birthdate,
                                    country: this.form.country,
                                    postcode: this.form.postcode,
                                    address: this.form.address,
                                    unit: this.form.unit,
                                    city: this.form.city,
                                    state: this.form.state,
                                    save_earth: this.form.save_earth,
                                    cart: this.gifts.map(item => {
                                        return {
                                            name: item.name,
                                            price: item.price,
                                            quantity: item.quantity
                                        };
                                    }),
                                    recurring_gift: this.monthlyGift,
                                    onetime_gift: this.oneTimeGift,
                                    total_contribution:
                                        this.monthlyGift + this.oneTimeGift
                                }
                            };

                            window.ReWebSDK.customEvent(eventData);

                            setTimeout(() => {
                                window.location.replace(
                                    `/${this.adoptee.slug}/adoption/success`
                                );
                            }, 20000);
                            //   }
                            // })
                        } else {
                            this.sendSubscription(
                                this.form,
                                this.monthlyGift,
                                this.oneTimeGift,
                                this.adoptee,
                                "FR_Adoption_Hero_Failed",
                                () => console.log("donation-failed")
                            );

                            this.wait = 0;
                            Swal.fire(
                                "Oh no!",
                                " Transaction failed with unknown error. Please contact our support at member@wwf.sg for help.",
                                "error"
                            );
                        }
                    }
                })
                .catch(err => {
                    this.sendSubscription(
                        this.form,
                        this.monthlyGift,
                        this.oneTimeGift,
                        this.adoptee,
                        "FR_Adoption_Hero_Failed",
                        () => console.log("donation-failed")
                    );

                    console.log(err);
                });
        },
        sendSubscription(
            form,
            monthlyGift,
            oneTimeGift,
            adoptee,
            tags,
            callback
        ) {
            if (
                !form.email?.includes("@wwf") &&
                !(
                    form.email?.includes("rsltks") &&
                    form.email?.includes("dinesh")
                )
            ) {
                callback;
                return false;
            }

            let RID_ = null;
            let CID_ = null;
            RID_ = GetValues("rid");
            CID_ = GetValues("cid");

            if (RID_ == undefined || !RID_) {
                RID_ = "";
            }
            if (CID_ == undefined || !CID_) {
                CID_ = "";
            }

            let arrCart = [];
            for (const item in form.cart) {
                if (form.cart.hasOwnProperty(item)) {
                    const gift = this.form.cart[item];
                    if (gift.quantity > 0) {
                        arrCart.push(gift.name);
                    }
                }
            }

            // var apiData = {
            //     First_name: form.firstname, // exist
            //     MobileNo: this.user.phone, // new
            //     EmailID: form.email, // exists
            //     Birthdate: form.birthdate, // change from Date_of_Birth
            //     Address: form.address, // exists
            //     Postcode: form.postcode, // change from Post_code
            //     City: form.city, // exists
            //     State: form.state, // exists
            //     Country: form.country, // exists
            //     PaymentFormFrequency: form.interval, // change from Payment_frequency
            //     Adoption_Species_Name: adoptee?.name, // change from Animals_name
            //     Adoption_Add_On: arrCart.join(", "), // new
            //     TFR_ID: this.additional.tfrID, // new
            //     Tags: tags, // exists
            //     formid: "39", // change value from 3
            //     apikey: "204e7b64_558b_4aa7_9dcc_4e4e7ea7187f", // exists
            //     SourceURL: getsourceurl(), // exists
            //     pagereferrerurl: getsourceurl(), // exists
            //     rid: RID_, // exists
            //     cid: CID_, // exists
            //     pagetitle: getpagetitle() // exists
            // };

            // let apiData = {
            //     EmailID: form.email,
            //     Address: form.address,
            //     Unit: form.unit,
            //     Country: form.country,
            //     Post_code: form.postcode,
            //     State: form.state,
            //     City: form.city,
            //     Date_of_Birth: form.birthdate,
            //     Payment_frequency: form.interval,
            //     First_name: form.firstname,
            //     Animals_name: adoptee?.name,
            //     Contribute: monthlyGift + oneTimeGift,
            //     formid: "3",
            //     dbId: "204e7b64_558b_4aa7_9dcc_4e4e7ea7187f",
            //     SourceURL: getsourceurl(),
            //     pagereferrerurl: getsourceurl(),
            //     rid: RID_,
            //     cid: CID_,
            //     pagetitle: getpagetitle(),
            //     Tags: tags
            // };

            const apiData = {
                First_name: form.firstname, // exist
                MobileNo: this.user.phone, // new
                EmailID: form.email, // exists
                Birthdate: form.birthdate, // change from Date_of_Birth
                Address: form.address, // exists
                Postcode: form.postcode, // change from Post_code
                City: form.city, // exists
                State: form.state, // exists
                Country: form.country, // exists
                PaymentFormFrequency: form.interval, // change from Payment_frequency
                Adoption_Species_Name: adoptee?.name, // change from Animals_name
                Donation_Amount: monthlyGift,
                Adoption_Add_On: oneTimeGift,
                TFR_ID: this.additional.tfrID,
                Tags: tags,
                formid: "39",
                dbId: "204e7b64_558b_4aa7_9dcc_4e4e7ea7187f",
                SourceURL: getsourceurl(),
                pagereferrerurl: getsourceurl(),
                rid: RID_,
                cid: CID_,
                pagetitle: getpagetitle(),
                Notsubmit: "no"
            };

            console.log("donation", apiData);

            let formData = new FormData();

            formData = this.objectToFormData(apiData);

            fetch("https://resu.io/Subscription/IndexInsertAPITemp", {
                method: "post",
                body: formData
            }).then(function(response) {
                console.log("result", response);
                callback;
            });
        },

        // Function to add all object properties to FormData
        objectToFormData(obj, formData = new FormData(), parentKey = "") {
            for (let key in obj) {
                if (obj.hasOwnProperty(key)) {
                    // Append the value to FormData
                    formData.append(key, obj[key]);
                }
            }
            return formData;
        },

        change(event) {
            if (event.error) {
                this.errors.card_info = event.error.message;
            } else {
                this.errors.card_info = "";
            }
        }
    },
    computed: {
        selectedTier() {
            let tier = this.tiers.filter(tier => tier.id == this.form.tier);

            if (tier.length) return tier[0];

            return this.tiers[0];
        },

        selectedAmount() {
            return this.selectedTier.amount;
        },

        plans() {
            return {
                monthly: this.selectedAmount,
                biannual: this.selectedAmount * 6,
                annual: this.selectedAmount * 12
            };
        },

        oneTimeGift() {
            console.log(this.form.cart);

            var sum = 0;
            for (const item in this.form.cart) {
                if (this.form.cart.hasOwnProperty(item)) {
                    const gift = this.form.cart[item];
                    sum += gift.price * gift.quantity;
                }
            }
            this.onetimegift_total = sum;
            return sum;
        },

        monthlyGift() {
            if (this.sponsor != 1) {
                switch (this.form.interval) {
                    case "monthly":
                        return this.plans.monthly;
                        break;
                    case "biannual":
                        return this.plans.biannual;
                        break;
                    case "annual":
                        return this.plans.annual;
                        break;
                }
            } else {
                return 0;
            }
        }
    },

    watch: {
        step: function(oldVal, newVal) {
            this.is_form_dirty = true;
        }
    },
    mounted() {
        this.gifts.forEach(gift => {
            gift.quantity = 0;
            this.$set(this.form.cart, gift.id, gift);
        });

        // When the user refresh/leave the current tab
        window.addEventListener("beforeunload", event => {
            if (this.is_form_dirty && !this.is_form_success) {
                const resEvent = {
                    eventName: "Abondened Donation"
                };
                console.log(resEvent);
                window.ReWebSDK.customEvent(resEvent);
            }
        });
    },

    beforeDestroy() {
        window.removeEventListener("beforeunload", event => {
            //
        });
    }
};
</script>
<style scoped>
.cart {
    box-shadow: 0.2px 0.2px 20px grey;
    border-radius: 3px;
    background-color: white;
    max-height: fit-content !important;
    margin-top: 4.5rem !important;
    max-width: 40% !important;
    padding: 0px 20px 0px 20px !important;
}
.gift.row.no-gutters.mb-4 {
    margin-bottom: 1rem !important;
}
.row.no-gutters.align-items-center h5 {
    font-family: "WWF";
    font-size: 1.5rem;
}
#button-addon1 {
    padding: 0.1rem 0.8rem;
    margin: 3px;
    font-size: 1.5rem;
    background-color: #f58220;
    color: #ffffff;
    border: none !important;
}
#button-addon2 {
    padding: 0.2rem 1rem;
    margin: 3px;
    font-size: 1.5rem;
    background-color: #f58220;
    color: #ffffff;
    border: none !important;
}
.badge-pill {
    border-radius: 50%;
    padding: 0.4rem 0.6rem;
}
h6.text-orange {
    font-family: "Open Sans";
    font-weight: 900 !important;
    font-size: 1rem !important;
}

table.table.table-borderless.table-hover.table-sm {
    font-size: 1rem !important;
    font-family: "Open Sans" !important;
    font-weight: 400 !important;
}

.row.no-gutters {
    font-family: "Open Sans";
    font-size: 1rem !important;
    font-weight: 400 !important;
}
.gift.row.no-gutters h5 {
    font-size: 1.3rem !important;
    font-family: "WWF";
}

#monthly {
    padding-bottom: 15px;
}
.btn {
    border-radius: 0rem;
}
header {
    background-color: transparent;
    position: absolute;
    width: 100%;
    top: 0;
    left: 0px;
}
.user-state .nav-item {
    display: none !important;
}
.contribution-items {
    padding: 2rem 1.2rem 0rem 1.2rem !important;
}
#adopt {
    margin: 0;
    padding: 0;
    min-width: 100%;
}
#cover-img {
    background-image: url("/images/pages/checkout/Hero_Forest.jpg");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    height: auto;
}
.card-body {
    box-shadow: 0.2px 0.2px 20px gray;
    border-radius: 3px;
    background-color: white;
    margin-bottom: 0px;
}
.card-body h1 {
    font-family: "WWF";
    font-size: 3rem;
    text-align: center;
    line-height: 1;
    padding-bottom: 10px;
}
.card-body button {
    background-color: #f58220;
    border: none;
    font-weight: bolder;
    font-family: "WWF";
    font-size: 1.5em;
    padding: 10px 25px 15px 25px;
}
.payment-frequency {
    border-radius: 50%;
    border: 4px solid white;
    height: 110px;
    width: 110px;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #f5f5f5;
}
.payment-frequency.text-center {
    font-size: 0.8rem;
    font-weight: 400;
}
.payment-frequency.text-center:hover {
    cursor: pointer;
}
.payment-frequency-section .col-4 {
    padding: 0;
}
.payment-frequency-section .col-4 p {
    margin: 0;
}
.stripe-card {
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    padding: 0.375rem 0.75rem;
    height: calc(1.6em + 0.75rem + 2px);
}
.payment-frequency-section .active {
    border-color: #ffffff;
    background-color: #f58220;
    color: white;
}

.cover-info {
    display: flex;
    justify-content: center;
    align-items: center;
}
.cover-info h1 {
    color: #ffca00;
    font-size: 3rem;
    margin-bottom: 1.5rem !important;
}
.cover-info h2 {
    color: white;
    font-size: 2rem;
}
.cover-info p {
    color: white;
    font-size: 1rem;
}
.cover-info h1,
.cover-info h2 {
    font-family: "WWF";
    line-height: 1;
}
#left-div {
    padding: 0;
    background-color: black;
    min-height: 100%;
    position: relative;
}
#left-div .col-6 {
    padding: 0;
}
#select-package {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 90vh;
}
#select-package #subscription {
    margin-top: 20px;
    margin-bottom: 50px;
}
#select-package ul {
    list-style: none;
}
#select-package ul li {
    margin-top: 10px;
    font-weight: normal;
    font-size: 0.9rem;
}
#select-package .circle {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 700;
    font-size: 1rem;
}
#select-package .circle:hover {
    background-color: #f58220;
    color: white;
    cursor: pointer;
}
#select-package .circle-nactive {
    background-color: white;
}
#select-package .circle-active {
    background-color: #f58220;
    color: white;
}
#select-package .card-body {
    background-color: #ffca00;
}
#select-package .col-12 {
    background-color: #f58220;
    font-size: 2em;
    color: white;
    padding-bottom: 6px;
}
#select-package #bah-btn:hover {
    cursor: pointer;
}
@media only screen and (max-width: 992px) {
    #select-package {
        min-height: 50vh;
    }
    .cover-info h2,
    .cover-info p {
        color: black;
    }
    #select-package .circle {
        width: 80px;
        height: 80px;
        border-radius: 50%;
        margin: auto;
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: 700;
        font-size: 0.9rem;
    }
    #select-package ul li {
        font-size: 0.7rem;
        font-weight: normal;
    }
    #adopt .p-5 {
        padding: 2.4rem !important;
    }

    header {
        display: none;
    }
}
@media only screen and (max-width: 768px) {
    .payment-frequency {
        height: 90px;
        width: 90px;
    }
    .payment-frequency div {
        font-size: 0.8em;
    }
    .cart {
        max-width: 95% !important;
        padding: 0px 10px 30px 10px !important;
        margin-left: 15px;
        margin-right: 15px;
    }
    .card-body button {
        font-size: 1.8em;
    }
    #button-addon1 {
        padding: 0rem 0.5rem;
        font-size: 1.2rem;
    }
    #button-addon2 {
        padding: 0rem 0.7rem;
        font-size: 1.2rem;
    }
    .card-body h1[data-v-7918a2c1] {
        font-size: 1.6rem;
    }
}
</style>
